
import {useNavigate} from 'react-router-dom';
import {Button} from 'antd';

import {INDEX} from '../../config/routes';

import cls from './Result.module.scss'


export const NoTime = () => {

    const navigate = useNavigate();

    return (

        <div className={cls.page}>

            <h1>Время вышло</h1>

            <div>Вы не ответили на все вопросы за отведённое время</div>

            <Button onClick={() => navigate(INDEX)}>Попробовать ещё раз</Button>

        </div>

    )
}


